<template>
  <div>
    <steam-tool-bar ></steam-tool-bar>


    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from "@/views/Public/tabbarTpl.vue"
import SteamToolBar from "@/pages/Steam/steamToolBar.vue"


export default {
  components: {
    Tabbar,
    SteamToolBar
  },
  created() {
    document.title = "蒸洗预约";
  },
  methods:{
    
  },
}
</script>
